import React from 'react'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import TrashIcon from '../../elements/icons/TrashIcon'

const CollegeAccountCard = ({account, deleteAccount}) => {
  return (
    <div className='w-full flex items-start gap-x-[10px]'>
        <div className='w-[60px]'>
            <div className='w-[60px] mt-[10px] h-[60px] rounded-full bg-vcm-purple flex items-center justify-center'>
                <p className='text-[18px] text-white'>
                    {account.accountName.split(' ')[0]?.charAt(0)}
                    {account.accountName.split(' ')[1]?.charAt(0)}
                </p>
            </div>
        </div>
        <div className='w-full'>
            <p className='font-wix-mf-display font-[550]'>{account.accountName}</p>
            <p className='text-sm'>{account.bankName} - <span className='font-space-grotesk text-[16px] font-[500]'>{account.accountNumber}</span></p>
            <p className='text-sm text-gray-500 mt-[10px]'>{account.description}</p>

            <div className="w-full flex items-center justify-between mt-3 border-t pt-3">
                <button onClick={()=>{}} className='text-sm flex flex-row items-center gap-x-3 text-vcm-purple hover:text-gray-400 transition duration-200'>View Account <ArrowIcon className={`w-4 h-4`} /></button> 

                <button onClick={()=>{}} className='p-1 rounded bg-transparent hover:bg-vcm-light-purple hover:bg-opacity-20 transition duration-200 text-gray-400 hover:text-vcm-purple'>
                    <TrashIcon className={`w-5 h-5`} />
                </button>
            </div>
        </div>
    </div>
  )
}

export default CollegeAccountCard